// Hash router minimaliste — pas de dépendance externe.
// Routes supportées :
//   #/                                                 → Sociétés (défaut)
//   #/societes                                         → Sociétés
//   #/societes/:code                                   → Société détail
//   #/societes/:code/dossiers/:id                      → Dossier annuel
//   #/audit                                            → Audit log

import { useEffect, useState } from 'react'

export type Route =
  | { name: 'societes' }
  | { name: 'societe'; code: string }
  | { name: 'dossier'; code: string; dossierId: string }
  | { name: 'audit' }
  | { name: 'unknown'; path: string }

export function parseHash(hash: string): Route {
  const clean = hash.replace(/^#\/?/, '').replace(/^\//, '')
  if (clean === '' || clean === 'societes') return { name: 'societes' }
  if (clean === 'audit') return { name: 'audit' }

  const societeMatch = clean.match(/^societes\/([^/]+)$/)
  if (societeMatch) return { name: 'societe', code: decodeURIComponent(societeMatch[1]) }

  const dossierMatch = clean.match(/^societes\/([^/]+)\/dossiers\/([^/]+)$/)
  if (dossierMatch) {
    return {
      name: 'dossier',
      code: decodeURIComponent(dossierMatch[1]),
      dossierId: decodeURIComponent(dossierMatch[2])
    }
  }

  return { name: 'unknown', path: clean }
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseHash(window.location.hash))
  useEffect(() => {
    const onHash = () => setRoute(parseHash(window.location.hash))
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])
  return route
}

export function navigate(path: string) {
  window.location.hash = path.startsWith('#') ? path : `#${path}`
}

export function href(path: string): string {
  return `#${path.startsWith('/') ? path : '/' + path}`
}
